import Vue from 'vue';
import Router from 'vue-router';
import {BASE_URL} from "@/utils/baseUrl";
Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export const appRouter = [
  {
    path: '*',
    redirect: '/login',
  },
  {
    path: '',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/login'),
  },
  {
    path: '/singleLogin',
    name: 'singleLogin',
    component: () => import('@/views/login/index'),
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
  },
  {
    path: '/detection',
    component: () => import('@/views/env-detection/index.vue'),
  },
  {
    path: '/detection-outer',
    component: () => import('@/views/env-detection/outer.vue'),
  },
  {
    path: '/projectList',
    name: 'projectList',
    component: () => import('@/views/project-list/index'),
  },
  {
    path: '/historyList',
    name: 'historyList',
    component: () => import('@/views/history-project-list/index'),
  },
  {
    path: '/checkPdf',
    name: 'checkPdf',
    component: (resolve) => {
      require(['@/components/tips/tools/pdfFileView.vue'], resolve);
    },
  },
  {
    path: '/consultNewPdf',
    name: 'consultNewPdf',
    component: (resolve) => {
      require(['@/views/bidder/sx-report/consult-file.vue'], resolve);
    },
  },
  {
    path: '/consultSignature',
    name: 'consultSignature',
    component: () => import('@/views/bidder/sx-report/components/KgSignature'),
  },
  {
    path: '/resultPdf',
    name: 'resultPdf',
    component: (resolve) => {
      require(['@/components/dialog/result-file.vue'], resolve);
    },
  },
  {
    path: '/openResult',
    name: 'openResult',
    component: () => import('@/views/open-result/index'),
  },
  {
    path: '/KgSignature',
    name: 'KgSignature',
    component: () => import('@/views/open-result/components/KgSignature'),
  },
  // 磋商
  {
    path: '/bidder/consult',
    name: 'consult',
    component: () => import('@/views/dashboard/bidder.vue'),
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('@/views/dashboard/index'),
    children: [
      {
        path: '/index/bidOpen',
        name: 'bidOpen',
        component: () => import('@/views/index/bidOpen'),
      },
      {
        path: '/index/pubBidder',
        name: 'pubBidder',
        component: () => import('@/views/index/pubBidder'),
      },
      {
        path: '/index/fileDecrypt',
        name: 'fileDecrypt',
        component: () => import('@/views/index/fileDecrypt'),
      },
      {
        path: '/index/readBid',
        name: 'readBid',
        component: () => import('@/views/index/readBid'),
      },
      {
        path: '/index/signatureList',
        name: 'signatureList',
        component: () => import('@/views/index/signatureList'),
      },
      {
        path: '/index/finalists',
        name: 'finalists',
        component: () => import('@/views/index/finalists'),
      },
      {
        path: '/index/extract',
        name: 'extract',
        component: () => import('@/views/index/extract'),
      },
      {
        path: '/index/result',
        name: 'result',
        component: () => import('@/views/index/result'),
      },
      {
        path: '/index/extractBidder',
        name: 'extractBidder',
        component: () => import('@/views/index/extractBidder'),
      },
      {
        path: '/index/alternateBidder',
        name: 'alternateBidder',
        component: () => import('@/views/index/alternateBidder'),
      },
      {
        path: '/index/openbidderEnter',
        name: 'openbidderEnter',
        component: () => import('@/views/index/openbidderEnter'),
      },
      {
        path: '/index/bidderRandomCode',
        name: 'bidderRandomCode',
        component: () => import('@/views/index/bidderRandomCode'),
      },


      {
        path: '/index/openFinish',
        name: 'openFinish',
        component: () => import('@/views/bid-opening-end/index'),
      },
      {
        path: '/index/evalResult',
        name: 'evalResult',
        component: () => import('@/views/index/bidderResult'),
      },
      {
        path: '/index/openTwoFinish',
        name: 'openFinish',
        component: () => import('@/views/bid-opening-end/index'),
      },
      {
        path: '/index/pubResult',
        name: 'pubResult',
        component: () => import('@/views/index/pubResult'),
      },
      {
        path: '/index/bidPrice',
        name: 'bidPrice',
        component: () => import('@/views/index/bidPrice'),
      },
      {
        path: '/index/readTwoBid',
        name: 'readTwoBid',
        component: () => import('@/views/index/readBid'),
      },
      {
        path: '/index/openTwoFinish',
        name: 'openTwoFinish',
        component: () => import('@/views/bid-opening-end/index'),
      },
      {
        path: '/index/coefficient',
        name: 'coefficient',
        component: () => import('@/views/index/coefficient'),
      },
    ],
  },
      {
        path: '/live',
        component: () => import('@/views/live/index.vue'),
      },
      {
        path: '/clarifySign',
        name: 'clarifySign',
        component: () => import('@/views/bidder/sx-report/components/PdfOcx.vue'),
      },
];

let route = new Router({
  mode: 'hash',
  routes: appRouter,
  base: BASE_URL
});

export default route;
